












































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { RequestMessage, DataTablePagination } from '@/types/_'
import EventBus from '@/plugins/EventBus'
import { maskDate } from '@/utils/common'

@Component
export default class ViewFinanceiroMonitorIntegracao extends Vue {
  loadMonitorIntegracaoList: boolean = false

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get cargaLength() {
    return Math.ceil((this.getFinanceiroStore.totalItemsMonitorIntegracao || 0) / this.getFinanceiroStore.qtdPorPagina)
  }

  get getRequestMessage() {
    return new RequestMessage()
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPagina() {
    return this.getFinanceiroStore.pagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setPagina(value)
  }

  get headers() {
    return [
      { text: 'Data', value: 'createdOn', align: 'center', sortable: false },
      { text: 'Tipo', value: 'tipo', align: 'center', sortable: false },
      { text: 'Qtd Total', value: 'qtdItensTotal', align: 'center', sortable: false },
      { text: 'Qtd Processados', value: 'qtdItensProcessados', align: 'center', sortable: false },
      { text: 'Qtd Existentes', value: 'qtdItensExistentes', align: 'center', sortable: false },
      { text: 'Status', value: 'status', align: 'center', sortable: false },
      { text: 'Mensagem', value: 'mensagem', align: 'center', sortable: false }
    ]
  }

  get itensMonitorIntegracao() {
    return this.getFinanceiroStore.itemsMonitorIntegracao
  }

  get loadingMonitorIntegracaoList() {
    return this.loadMonitorIntegracaoList
  }

  set loadingMonitorIntegracaoList(value: boolean) {
    this.loadMonitorIntegracaoList = value
  }

  formatDate(date: string) {
    return maskDate(date)
  }

  async getResults(pagina: number) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getPagina = pagina
    await this.getFinanceiroStore.getItemsMonitorIntegracao()
    EventBus.$emit('clearLoadingRequest')
  }

  async updatePagination(pagination: DataTablePagination) {
    this.loadingMonitorIntegracaoList = true
    let param = ''
    if (pagination.sortBy) {
      param = pagination.descending ? `${pagination.sortBy}Desc` : `${pagination.sortBy}Asc`
    } else {
      param = ''
    }
    this.getFinanceiroStore.setSortBy(param)
    await this.getFinanceiroStore.getItemsMonitorIntegracao()
    this.loadingMonitorIntegracaoList = false
  }

  async mounted() {
    await this.getFinanceiroStore.getItemsMonitorIntegracao()
  }
}
